// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2oYE9","colCheckbox":"styles_colCheckbox__2Dqg2"};